import React from 'react';
import { Users } from 'lucide-react';
import { MultiSelectItem } from '@/shared/components/ui/MultiSelect';

interface ViewerTeamItemProps {
  id: string;
  name: string;
}

export const ViewerTeamItem: React.FC<ViewerTeamItemProps> = ({ id, name }) => {
  return (
    <MultiSelectItem
      key={id}
      value={id}
      badgeLabel={
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-100">
            <Users className="w-3.5 h-3.5 text-gray-600" />
          </div>
          <span className="text-sm">{name}</span>
        </div>
      }
      className="p-0 data-[selected=true]:bg-gray-50 data-[selected=true]:text-inherit cursor-pointer"
    >
      <div className="flex items-center p-3 border-b border-gray-100 last:border-b-0 hover:bg-gray-50 cursor-pointer">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 me-3">
          <Users className="w-5 h-5 text-gray-600" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900">{name}</p>
        </div>
      </div>
    </MultiSelectItem>
  );
};
